import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { RecoilRoot } from 'recoil'
import './App.css'
import ProtectedRoute from './components/common/ProtectedRoute'
import AttachmentPage from './pages/AttachmentPage'
import CreateProcess from './pages/CreateProcess'
import Dashboard from './pages/Dashboard'
import LoginPage from './pages/LoginPage'
import ProcessAccesses from './pages/ProcessAccesses'
import Processes from './pages/Processes'
import StagePage from './pages/StagePage'
import Users from './pages/Accounts'
import { useGetProfile } from './api/auth'
import { ThemeProvider } from '@mui/material'
import { theme } from './utils/theme'
import RTLProvider from './components/common/RTLProvider'

function App() {
  useGetProfile()

  return (
    <RTLProvider>
      <RecoilRoot>
        <ThemeProvider theme={theme}>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<ProtectedRoute />}>
                <Route path="/" element={<Processes />} />
                <Route path="/accounts" element={<Users />} />
                <Route path="/create" element={<CreateProcess />} />
                <Route path="/:pid" element={<Dashboard />} />
                <Route path="/:pid/accesses" element={<ProcessAccesses />} />
                <Route path="/:pid/stage/:sid" element={<StagePage />} />
                <Route
                  path="/:pid/stage/:sid/attachment/:aid"
                  element={<AttachmentPage />}
                />
              </Route>
              <Route path="/login" element={<LoginPage />} />
            </Routes>
          </BrowserRouter>
        </ThemeProvider>
      </RecoilRoot>
    </RTLProvider>
  )
}

export default App
